import api from './index.js'

export default {
  getPlugins() {
    return api.get('plugins');
  },

  enablePlugin(plugin) {
    return api.post('plugins/enable', { plugin_type: plugin });
  },
}